module.exports = __webpack_public_path__ + "img/IMG_0050-577x500.43862056.ae601895.png";